import { GUEST_TABLET_WORKSTATION_STORAGE_KEY } from "@/lib/guestTabletApi";

export const GUEST_TABLET_WORKSTATIONS_CACHE_KEY = "reception_guest_tablet_workstations_cache";

export type CachedGuestTabletWorkstation = { code: string; label: string };

export function readGuestTabletWorkstationCode(): string | null {
  if (typeof localStorage === "undefined") return null;
  const value = localStorage.getItem(GUEST_TABLET_WORKSTATION_STORAGE_KEY);
  return value && value.length > 0 ? value : null;
}

export function writeGuestTabletWorkstationCode(code: string | null): void {
  if (typeof localStorage === "undefined") return;
  if (code) {
    localStorage.setItem(GUEST_TABLET_WORKSTATION_STORAGE_KEY, code);
  } else {
    localStorage.removeItem(GUEST_TABLET_WORKSTATION_STORAGE_KEY);
  }
}

export function readCachedGuestTabletWorkstations(): CachedGuestTabletWorkstation[] {
  if (typeof localStorage === "undefined") return [];
  try {
    const raw = localStorage.getItem(GUEST_TABLET_WORKSTATIONS_CACHE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (row): row is CachedGuestTabletWorkstation =>
        typeof row === "object" &&
        row !== null &&
        typeof (row as CachedGuestTabletWorkstation).code === "string" &&
        typeof (row as CachedGuestTabletWorkstation).label === "string",
    );
  } catch {
    return [];
  }
}

export function writeCachedGuestTabletWorkstations(rows: CachedGuestTabletWorkstation[]): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(GUEST_TABLET_WORKSTATIONS_CACHE_KEY, JSON.stringify(rows));
}
